export const CURRENT_YEAR = -1;
export const CURRENT_YEAR_LABEL = 'Current year';
export const CURRENT_YEAR_VALUE = (new Date()).getFullYear();